import React from 'react';
import { Section, FadeIn, CTAButton } from './ui';
export const PricingSection = () => {
  return <Section className="bg-white" data-id="element-167">
      <FadeIn data-id="element-168">
        <div className="max-w-3xl mx-auto" data-id="element-169">
          <div className="text-center mb-12" data-id="element-170">
            <h2 className="text-3xl sm:text-4xl font-serif text-navy-900 mb-6" data-id="element-171">
              El Precio y la Oferta
            </h2>
            <p className="text-xl text-gray-600 mb-8" data-id="element-172">
              Piensa en lo que has gastado buscando sentirte mejor:
            </p>

            <div className="bg-cream-100 rounded-2xl p-6 inline-block text-left mb-12 border border-cream-200" data-id="element-173">
              <ul className="space-y-3 text-lg text-gray-700" data-id="element-174">
                <li data-id="element-175">
                  • Una consulta con psicólogo:{' '}
                  <span className="font-medium" data-id="element-176">$80 - $150</span>
                </li>
                <li data-id="element-177">
                  • Un curso de bienestar:{' '}
                  <span className="font-medium" data-id="element-178">$97 - $300</span>
                </li>
                <li data-id="element-179">
                  • Un retiro de fin de semana:{' '}
                  <span className="font-medium" data-id="element-180">$200 - $500</span>
                </li>
              </ul>
            </div>

            <p className="text-xl text-navy-900 font-medium max-w-2xl mx-auto mb-16" data-id="element-181">
              Este libro te da herramientas reales que puedes usar HOY, desde tu
              casa, a tu propio ritmo, en tu idioma, diseñadas para tu vida
              real.
            </p>
          </div>

          <div className="bg-navy-900 rounded-3xl p-8 sm:p-12 text-center text-white relative overflow-hidden shadow-2xl" data-id="element-182">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-amber-400 via-rose-400 to-amber-400" data-id="element-183"></div>

            <div className="mb-6" data-id="element-184">
              <span className="text-cream-100/60 text-lg line-through" data-id="element-185">
                Precio regular: $14.99 USD
              </span>
            </div>

            <div className="mb-8" data-id="element-186">
              <span className="text-amber-400 font-medium tracking-widest uppercase text-sm block mb-2" data-id="element-187">
                🎉 PRECIO DE LANZAMIENTO
              </span>
              <div className="text-6xl sm:text-7xl font-serif font-bold text-white" data-id="element-188">
                $6.39{' '}
                <span className="text-3xl font-sans font-normal text-cream-100/80" data-id="element-189">
                  USD
                </span>
              </div>
            </div>

            <div className="space-y-2 text-cream-100/90 mb-10" data-id="element-190">
              <p data-id="element-191">✓ Acceso inmediato</p>
              <p data-id="element-192">✓ Descarga directa</p>
              <p data-id="element-193">✓ Tuyo para siempre</p>
            </div>

            <CTAButton data-id="element-194" />
          </div>
        </div>
      </FadeIn>
    </Section>;
};